export const asc = (a, b) => (a < b ? -1 : a === b ? 0 : 1);
export const desc = (a, b) => (a > b ? -1 : a === b ? 0 : 1);
